import { SET_APP_NAME } from '../../constants/actionConstants';
import { AppName } from '../reducers/appReducer';

export const setCurrentAppName = (payload: AppName) => ({
  type: SET_APP_NAME,
  payload,
});
export default setCurrentAppName;
